import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';

const TermsPage = () => {
  const { language } = useLanguage();

  const content = language === 'fr' ? {
    title: 'Conditions d\u2019utilisation',
    lastUpdated: 'Derni\u00e8re mise \u00e0 jour\u00a0: 30 juillet 2026',
    sections: [
      {
        title: 'Aper\u00e7u',
        text: 'Ce site fournit des informations sur les produits MyGuardPod et dirige les clients vers notre boutique Etsy pour les achats. En utilisant ce site, vous acceptez les pr\u00e9sentes conditions d\u2019utilisation.'
      },
      {
        title: 'Fonction pr\u00e9vue des produits',
        text: 'Les produits MyGuardPod sont des \u00e9tuis de transport protecteurs destin\u00e9s \u00e0 contenir, organiser, identifier et transporter des contenants de m\u00e9dicaments d\u2019urgence et du mat\u00e9riel compatibles. Ils ajoutent une barri\u00e8re physique pendant le transport quotidien.'
      },
      {
        title: 'Limites de protection',
        text: 'La protection physique varie selon le mod\u00e8le, la configuration et les conditions d\u2019utilisation. Aucun \u00e9tui ne peut garantir qu\u2019un m\u00e9dicament ou son emballage demeurera intact apr\u00e8s une chute, un \u00e9crasement ou une mauvaise utilisation. Les \u00e9tuis ne sont ni st\u00e9riles, ni \u00e0 l\u2019\u00e9preuve des enfants, ni \u00e9tanches, ni submersibles, sauf mention contraire document\u00e9e pour un produit sp\u00e9cifique.'
      },
      {
        title: 'Absence de contr\u00f4le de temp\u00e9rature',
        text: 'Les \u00e9tuis MyGuardPod standards ne contr\u00f4lent pas la temp\u00e9rature. Ils ne chauffent, ne refroidissent, n\u2019isolent ni n\u2019amortissent activement les variations de temp\u00e9rature. Respectez toujours les consignes de conservation du fabricant du m\u00e9dicament.'
      },
      {
        title: 'Absence de garantie pharmaceutique',
        text: 'L\u2019utilisation d\u2019un produit MyGuardPod ne prolonge pas la dur\u00e9e de conservation et ne garantit ni l\u2019int\u00e9grit\u00e9, ni les conditions de conservation, ni la stabilit\u00e9, ni l\u2019efficacit\u00e9 d\u2019un m\u00e9dicament.'
      },
      {
        title: 'Compatibilit\u00e9 et v\u00e9rification par le client',
        text: 'Il incombe au client de v\u00e9rifier la compatibilit\u00e9 de son m\u00e9dicament avec un \u00e9tui donn\u00e9 : nom, dose, fabricant, type d\u2019emballage et dimensions indiqu\u00e9s dans la fiche du produit. Une apparence similaire ne garantit pas la compatibilit\u00e9. Les fabricants peuvent modifier leur emballage au fil du temps sans pr\u00e9avis. En cas de doute, contactez-nous avant l\u2019achat.'
      },
      {
        title: 'Absence de conseils m\u00e9dicaux',
        text: 'MyGuardPod ne fournit pas de conseils m\u00e9dicaux, pharmaceutiques ou cliniques, ni de protocoles d\u2019urgence, ni d\u2019instructions d\u2019administration. Suivez toujours l\u2019\u00e9tiquette de prescription, les instructions du fabricant du m\u00e9dicament, le plan d\u2019urgence \u00e9tabli avec votre professionnel de la sant\u00e9 et les exigences locales applicables.'
      },
      {
        title: 'Statut r\u00e9glementaire',
        text: 'Les \u00e9tuis MyGuardPod sont commercialis\u00e9s comme accessoires protecteurs de transport. MyGuardPod ne revendique aucune approbation, autorisation ou certification comme dispositif m\u00e9dical par un organisme de r\u00e9glementation.'
      },
      {
        title: 'Marques de tiers',
        text: 'Les noms de m\u00e9dicaments et de dispositifs mentionn\u00e9s sur ce site sont des marques appartenant \u00e0 leurs propri\u00e9taires respectifs. Leur mention indique uniquement la compatibilit\u00e9 pr\u00e9vue et n\u2019implique aucune affiliation, approbation ou recommandation.'
      },
      {
        title: 'Commandes et achats',
        text: 'Les achats sont effectu\u00e9s via notre boutique officielle sur Etsy. Les transactions, paiements, remboursements et litiges sont soumis aux politiques d\u2019Etsy. Chaque \u00e9tui est fabriqu\u00e9 sur commande au Qu\u00e9bec. Le d\u00e9lai de traitement actuel est indiqu\u00e9 dans la fiche Etsy correspondante.'
      },
      {
        title: 'Propri\u00e9t\u00e9 intellectuelle',
        text: 'Le nom MyGuardPod, le logo, les images, les textes et l\u2019ensemble du contenu de ce site sont la propri\u00e9t\u00e9 de MyGuardPod. Toute reproduction, distribution ou utilisation non autoris\u00e9e est interdite sans autorisation pr\u00e9alable.'
      },
      {
        title: 'Limitation de responsabilit\u00e9',
        text: 'Les produits sont fournis \u00ab\u00a0tels quels\u00a0\u00bb en tant qu\u2019accessoires de transport protecteurs. MyGuardPod ne peut \u00eatre tenu responsable des r\u00e9sultats m\u00e9dicaux, d\u2019une utilisation inappropri\u00e9e, ni de dommages r\u00e9sultant de l\u2019utilisation ou de l\u2019incapacit\u00e9 d\u2019utiliser nos produits.'
      },
      {
        title: 'Modifications',
        text: 'MyGuardPod se r\u00e9serve le droit de modifier ces conditions \u00e0 tout moment. Les modifications seront publi\u00e9es sur cette page avec une date r\u00e9vis\u00e9e. L\u2019utilisation continue du site apr\u00e8s modification constitue votre acceptation des nouvelles conditions.'
      },
      {
        title: 'Contact',
        text: 'Pour toute question concernant ces conditions d\u2019utilisation, contactez-nous \u00e0\u00a0:',
        after: 'contact@myguardpod.com'
      }
    ]
  } : {
    title: 'Terms of Service',
    lastUpdated: 'Last updated: July 30, 2026',
    sections: [
      {
        title: 'Overview',
        text: 'This website provides information about MyGuardPod products and directs customers to our Etsy store for purchases. By using this website, you agree to these terms of service.'
      },
      {
        title: 'Intended function of the products',
        text: 'MyGuardPod products are protective carrying cases intended to contain, organize, identify and transport compatible emergency-medication containers and supplies. They add a physical barrier during everyday carry.'
      },
      {
        title: 'Protection limits',
        text: 'Physical protection varies by model, configuration and conditions of use. No carrying case can guarantee that medication or its packaging will remain undamaged after a fall, crushing event or misuse. The cases are not sterile, child-resistant, waterproof or submersible unless a specific product has a separately documented rating.'
      },
      {
        title: 'No temperature control',
        text: 'Standard MyGuardPod cases do not control temperature. They do not actively heat, cool, insulate or buffer temperature changes. Always follow the medication manufacturer\u2019s storage instructions.'
      },
      {
        title: 'No pharmaceutical guarantee',
        text: 'Use of a MyGuardPod product does not extend shelf life and does not guarantee the integrity, storage conditions, stability or effectiveness of any medication.'
      },
      {
        title: 'Compatibility and customer verification',
        text: 'It is the customer\u2019s responsibility to verify the compatibility of a specific medication with a given case: name, dose, manufacturer, packaging type and dimensions listed in the product description. A similar appearance does not guarantee compatibility. Manufacturers may update their packaging over time without notice. When in doubt, contact us before purchasing.'
      },
      {
        title: 'No medical advice',
        text: 'MyGuardPod does not provide medical, pharmaceutical or clinical advice, emergency protocols, or administration instructions. Always follow the prescription label, the medication manufacturer\u2019s instructions, your healthcare professional\u2019s emergency plan and applicable local requirements.'
      },
      {
        title: 'Regulatory status',
        text: 'MyGuardPod cases are sold as protective carrying accessories. MyGuardPod does not claim medical-device approval, authorization or certification by any regulatory body.'
      },
      {
        title: 'Third-party trademarks',
        text: 'Medication and device names referenced on this website are trademarks of their respective owners. References indicate intended fit only and do not imply affiliation, approval or endorsement.'
      },
      {
        title: 'Orders and purchases',
        text: 'Purchases are made through our official Etsy store. Transactions, payments, refunds and disputes are subject to Etsy\u2019s policies. Each case is made to order in Qu\u00e9bec. Current processing times are shown on the corresponding Etsy listing.'
      },
      {
        title: 'Intellectual property',
        text: 'The MyGuardPod name, logo, images, text and all website content are the property of MyGuardPod. Unauthorized reproduction, distribution or use is prohibited without prior permission.'
      },
      {
        title: 'Limitation of liability',
        text: 'Products are provided \u201cas is\u201d as protective carrying accessories. MyGuardPod shall not be held liable for medical outcomes, improper use of the products, or damages arising from the use or inability to use our products.'
      },
      {
        title: 'Modifications',
        text: 'MyGuardPod reserves the right to modify these terms at any time. Changes will be posted on this page with a revised update date. Continued use of the website after modification constitutes your acceptance of the new terms.'
      },
      {
        title: 'Contact',
        text: 'For questions regarding these terms of service, you can reach us at:',
        after: 'contact@myguardpod.com'
      }
    ]
  };

  return (
    <main className="pt-20 sm:pt-24">
      {/* Hero */}
      <section className="bg-neutral-50 py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <h1 className="font-outfit font-black text-4xl sm:text-5xl tracking-tight text-[#1a1a1a] mb-4">
              {content.title}
            </h1>
            <p className="font-manrope text-neutral-500">{content.lastUpdated}</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          {content.sections.map((section, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.03 }}
            >
              <h2 className="font-outfit font-bold text-xl text-[#1a1a1a] mb-3">{section.title}</h2>
              <p className="font-manrope text-neutral-600 leading-relaxed">{section.text}</p>
              {section.after && (
                <p className="font-manrope text-[#E31B23] font-semibold mt-2">{section.after}</p>
              )}
            </motion.div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default TermsPage;
